import { AdminApprovalLimit } from './AdminApprovalLimit';
import { TokenApprovalLimit } from './TokenApprovalLimit';
import { OrgPermission } from '../../../../../../backend/src/organisation/organisation-permission';
import { useOrgPermissions } from '@/hooks/orgPermissions';

export const TokenLimits = () => {
  const { isEnabled } = useOrgPermissions();
  const isAdminApprovalEnabled = isEnabled(OrgPermission.AdminApproval);

  return (
    <div className="space-y-6">
      <TokenApprovalLimit />
      {isAdminApprovalEnabled && <AdminApprovalLimit />}
    </div>
  );
};
